<div class="mt-5 mb-3 logo">
  <img src="/assets/img/logo_payoff.svg" />
</div>
<mat-nav-list *ngIf="loggedUser">
  <a
    mat-list-item
    routerLink="/users"
    (click)="closeSidenav()"
    routerLinkActive="list-item-active"
    *ngIf="loggedUser.role === roles.Company"
  >
    <span class="nav-caption" translate>Dipendenti</span>
  </a>
  <a
    mat-list-item
    [routerLink]="'/users/' + loggedUser.id"
    (click)="closeSidenav()"
    routerLinkActive="list-item-active"
    *ngIf="
      loggedUser.role === roles.Employee || loggedUser.role === roles.Freelance
    "
  >
    <span class="nav-caption" translate>Profilo</span>
  </a>
  <a
    mat-list-item
    routerLink="/admin/companies"
    (click)="closeSidenav()"
    routerLinkActive="list-item-active"
    *ngIf="
      loggedUser.role === roles.SuperAdmin ||
      loggedUser.role === roles.MedicalConsultant
    "
  >
    <span class="nav-caption" translate>Aziende</span>
  </a>
  <a
    mat-list-item
    routerLink="/admin/company-profile"
    (click)="closeSidenav()"
    routerLinkActive="list-item-active"
    *ngIf="
      loggedUser.role === roles.Company || loggedUser.role === roles.Freelance
    "
  >
    <span class="nav-caption" translate>Profilo azienda</span>
  </a>
  <a
    mat-list-item
    routerLink="/report"
    (click)="closeSidenav()"
    routerLinkActive="list-item-active"
    *ngIf="
      loggedUser.role === roles.Company || loggedUser.role === roles.Freelance
    "
  >
    <span class="nav-caption" translate>Report</span>
  </a>
  <a
    mat-list-item
    routerLink="/medical-centers"
    (click)="closeSidenav()"
    routerLinkActive="list-item-active"
  >
    <span class="nav-caption" translate>Centri autorizzati</span>
  </a>
  <a
    mat-list-item
    routerLink="/country-cards"
    (click)="closeSidenav()"
    routerLinkActive="list-item-active"
    *ngIf="
      loggedUser.role === roles.Company || loggedUser.role === roles.Freelance
    "
  >
    <span class="nav-caption" translate>Schede paesi </span>
  </a>
  <mat-divider></mat-divider>
  <a mat-list-item (click)="onLogout()">
    <!-- <mat-icon class="mr-2">exit_to_app</mat-icon> -->
    <span class="nav-caption" translate>Logout</span>
  </a>
</mat-nav-list>
<footer class="d-flex align-items-center justify-content-center flex-column">
  <!-- <div class="languages">
    <img *ngFor="let supportedLanguage of supportedLanguages" [class]="{'selected': selectedLanguage===supportedLanguage.langCode}" src="../../../assets/img/countries/{{supportedLanguage.flagCode}}.svg" (click)="setLanguage(supportedLanguage.langCode)">
  </div> -->
  <a
    href="https://www.iubenda.com/privacy-policy/95796725"
    class="iubenda-white iubenda-embed"
    title="Privacy Policy "
    translate
    >Privacy Policy</a
  >
  <script type="text/javascript">
    (function (w, d) {
      var loader = function () {
        var s = d.createElement('script'),
          tag = d.getElementsByTagName('script')[0];
        s.src = 'https://cdn.iubenda.com/iubenda.js';
        tag.parentNode.insertBefore(s, tag);
      };
      if (w.addEventListener) {
        w.addEventListener('load', loader, false);
      } else if (w.attachEvent) {
        w.attachEvent('onload', loader);
      } else {
        w.onload = loader;
      }
    })(window, document);
  </script>
  <a
    href="https://www.iubenda.com/privacy-policy/95796725/cookie-policy"
    class="iubenda-white iubenda-embed"
    title="Cookie Policy "
    translate
    >Cookie Policy</a
  >
  <script type="text/javascript">
    (function (w, d) {
      var loader = function () {
        var s = d.createElement('script'),
          tag = d.getElementsByTagName('script')[0];
        s.src = 'https://cdn.iubenda.com/iubenda.js';
        tag.parentNode.insertBefore(s, tag);
      };
      if (w.addEventListener) {
        w.addEventListener('load', loader, false);
      } else if (w.attachEvent) {
        w.attachEvent('onload', loader);
      } else {
        w.onload = loader;
      }
    })(window, document);
  </script>
  <span translate>
    my eJob © {{ year }} <br /><small> {{ version }} </small>
  </span>
</footer>
